import type { OrganizationForCarRecord } from '@navio/nsdk';
import { useEffect } from 'react';
import type { SelectedOrganization } from '../types/stationaryBooking';

/**
 * Keep store org choice in sync with organizations-for-car results:
 * auto-select single org; clear when the choice is no longer in the list.
 */
export function useStationaryOrganizationSelection({
  organizationsForCar,
  selectedOrganization,
  setSelectedOrganization
}: {
  organizationsForCar: OrganizationForCarRecord[] | undefined;
  selectedOrganization: SelectedOrganization | null;
  setSelectedOrganization: (organization: OrganizationForCarRecord | null) => void;
}) {
  useEffect(() => {
    if (!organizationsForCar) {
      return;
    }

    if (organizationsForCar.length === 1 && !selectedOrganization) {
      setSelectedOrganization(organizationsForCar[0]!);
    } else if (
      selectedOrganization &&
      !organizationsForCar.some((org) => org.organizationId === selectedOrganization.organizationId)
    ) {
      setSelectedOrganization(null);
    }
  }, [organizationsForCar, selectedOrganization, setSelectedOrganization]);
}
